export default class EventTrackingEvent extends CustomEvent {
  static eventName = 'event-tracking-event';

  constructor(detail) {
    super(EventTrackingEvent.eventName, {
      detail,
    });
  }
}
